let getSeparator = (lang) => {
    switch (lang) {
        case "fr":
            return /[\s\n/\-]+/
        case "nl":
            return /[\s\n/]+/
        default:
            return /[\s\n/\-]+/
    }
}

let isAlphabetic = (word) => {
    return word.match (/[A-Za-z\u00C0-\u00FF]/g)
}

let isFilled = v => {
    return v !== "" && v !== `<p><br></p>` && v
}

let normalizeApostrophe = (text) => {
    let smart = `’`, straight = `'`;
    return text.replace (smart, straight)
}

let regEscapeSymbols = (word) => {
    return word.replace (/[.^$*+-?()\[\]{}|—\\]/g, "")
}

let regIndexOf = (text, regExpression) => {
    return text.search (regExpression)
}

let regLastIndexOf = (text, regExpression) => {
    let exp = new RegExp (regExpression, 'ig')
    let bef = -2, aft = -1

    while (bef < aft) {
        exp.test (text)
        bef = aft
        aft = exp.lastIndex
    }
    return bef - 1;
}

let checkSpelling = (text, dict, misspells, setMisspells, castOffs) => {
    let word = normalizeApostrophe(regEscapeSymbols (text))

    return isAlphabetic (word) &&
        !castOffs.includes (word) &&
        !misspells.includes (word) &&
        dict && !dict.lookup (word).found && word &&
        (!startsWithAccentual (word) || (startsWithAccentual (word) && !checkDiacritics (word, dict))) &&
        setMisspells (v => v.includes (word) ? v : v.concat (word))
}

let splitText = async (text, lang) => {
    let s = new Set ()

    await text.split (getSeparator (lang))
        .reduce ((_, word) => s.add (word), null)
    return s
}

let checkAll = async (listToCheck, dict) => {
    let s = new Set ()

    if (listToCheck.values) {
        for await (let el of listToCheck) {
            let word = normalizeApostrophe(regEscapeSymbols (el))

            if (isAlphabetic (word) && dict && !dict.lookup (word).found && word && (!startsWithAccentual (word) || (startsWithAccentual (word) && !checkDiacritics (word, dict)))) {
                s.add (word)
                listToCheck.delete (word)
            }
        }
    }

    return [...s]
}

let checkTexts = async (text, lang, dict) => {

    return await splitText (text, lang)
        .then (splintedText => checkAll (splintedText, dict))
}

// Format Consistency Checker
// french diacritics: À Â Ä Ç É È Ê Ë Î Ï Ô Ö Ù Û Ü Ÿ

let diacritics = {
    "A": ["à", "â", "ä"],
    "C": ["ç"],
    "E": ["é", "è", "ê", "ë"],
    "I": ["î", "ï"],
    "O": ["ô", "ö"],
    "U": ["ù", "û", "ü"],
    "Y": ["ÿ"],
}

let startsWithAccentual = (word) => {
    return Object.keys (diacritics).includes (word.charAt (0))
}

let checkDiacritics = (word, dict) => {
    for (let el of diacritics[word.charAt (0)]) {
        if (dict.lookup (el.concat (word.substring (1))).found) {
            return true
        }
    }
    return false
}

export {
    getSeparator,
    isFilled,
    regEscapeSymbols,
    regLastIndexOf,
    regIndexOf,
    checkSpelling,
    splitText,
    checkAll,
    checkTexts
}